import React, { useState } from "react";

import Modal from "react-modal";
import SubscribeBlock from "../subscribe-block";
import PartnersForm from "../v2/form/partner-form";
import Dialog from "../v2/dialog";

const SubscribePopUp = (props) => {
    const [isOpen, setIsOpen] = useState(false);

    function toggleModal() {
        setIsOpen(!isOpen);
    }

    return (
        <div className="App">
            <button className={'primary arrow'} onClick={toggleModal}>Read ebooks and whitepaper</button>
            <Dialog
                isOpen={isOpen}
                position={"center"}
                onClose={() => {
                    setIsOpen(false);
                }}
                size={"sx"}
                verticalCenter={true}
            >
                <SubscribeBlock isWhitepaper={true}/>
            </Dialog>
        </div>
    );
}
export default SubscribePopUp;